import { useFormContext } from "react-hook-form";



import NumberInput from "@/components/form-controls/NumberInput";



export default function WorkForcesForm() {
    const { register, formState: { errors }, clearErrors, } = useFormContext()

    const handleInputBlur = (fieldName: string) => {
        if (errors[fieldName]) {
            clearErrors(fieldName);
        }
    }
    console.log(errors, "errors")
    console.log(register("localPermanentEmployees"), "register")

    return (
        <div className="w-full">
            <h1 className="text-lg font-bold">Workforce</h1>
            <p className='text-xs text-[#041528]'>Indicate the number and type of employees your project will involve during its operation.</p>
            <div className="mt-5 grid grid-cols-1 gap-3 w-full">
                 <div className="flex items-center w-full text-sm gap-3 ">
                    <span className='text-nowrap text-black font-semibold'>Local Employees</span>
                    <span className="border border-[#E3E7E8] w-full h-[0.5px]"/>
                </div>
    
                 <NumberInput
                    label="Permanent employees"
                    placeholder="Enter number of permanent employees"
                    onBlur={() => handleInputBlur("localPermanentEmployees")}
                    error={errors.localPermanentEmployees?.message?.toString()}
                    register={register("localPermanentEmployees", {
                        required: "Number of permanent employees is required",
                    })}
                    required
                    className="col-span-2 relative"
                />

                 <NumberInput
                    label="Temporary employees"
                    placeholder="Enter number of temporary employees"
                    onBlur={() => handleInputBlur("localTemporaryEmployees")}
                    error={errors.localTemporaryEmployees?.message?.toString()}
                    register={register("localTemporaryEmployees", {
                        required: "Number of temporary employees is required",
                    })}
                    required
                    className="col-span-2 relative"

                />
         

                <div className="flex items-center w-full text-sm gap-3 ">
                    <span className='text-nowrap text-black font-semibold'>Foreign Employees</span>
                    <span className="border border-[#E3E7E8] w-full h-[0.5px]"/>
                </div>
         
                <NumberInput
                    label="Permanent employees"
                    placeholder="Enter number of permanent employees"
                    onBlur={() => handleInputBlur("foreignPermanentEmployees")}
                    error={errors.foreignPermanentEmployees?.message?.toString()}
                    register={register("foreignPermanentEmployees", {
                        required: "Number of foreign employees permanent is required",
                    })}
                    required
                    className="col-span-2 relative"

                />

                 <NumberInput
                    label="Temporary employees"
                    placeholder="Enter number of temporary employees"
                    onBlur={() => handleInputBlur("foreignTemporaryEmployees")}
                    error={errors.foreignTemporaryEmployees?.message?.toString()}
                    register={register("foreignTemporaryEmployees", {
                        required: "Number of foreign employees temporary is required",
                    })}
                    required
                    className="col-span-2 relative  "

                />
            </div>
        </div>
    )
}